import type { WorkItemDto } from '@customTypes/types';

import { ManageCurrentContractView } from './ManageCurrentContractView';
import { useManageCurrentContractView } from './useManageCurrentContractView';

export const ManageCurrentContractContainer = ({
  workItem
}: {
  workItem: WorkItemDto;
}) => {
  const {
    functions: { requestEndDate, acceptNewEndDate }
  } = useManageCurrentContractView({ workItem });
  return (
    <ManageCurrentContractView
      acceptNewEndDate={acceptNewEndDate}
      requestEndDate={requestEndDate}
      workItem={workItem}
    />
  );
};
